var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 11,
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.74462 5.2L10.4 8.85552L8.85518 10.4L5.1998 6.74488L1.54482 10.4L0 8.85552L3.65498 5.2L0 1.54448L1.54482 0L5.1998 3.65512L8.85518 0L10.4 1.54448L6.74462 5.2Z",
  fill: "#888888"
})));
export default SvgIconClose;